import React from "react";
import manage from "../assets/img/manage.png";
import maker from "../assets/img/maker.png";
import develop from "../assets/img/develop.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Company() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex justify-between gap-10 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center w-1/3 gap-5 p-5 shadow-lg bg-gradient-to-b from-manage1 to-manage2 rounded-3xl">
          <img src={manage} alt="logo" className=" h-60" />
          <div className="flex flex-col w-full gap-3 px-5">
            <p className="text-xl font-semibold text-gray-800">경영지원팀</p>
            <div className="text-base leading-6 text-gray-600">
              <p>· 다른 팀들이 업무에만 집중할 수 있도록 서류와 회계처리를 지원해주는 만능 서포터</p>
            </div>
          </div>
        </section>
        {/* section2 */}
        <section className="flex flex-col items-center w-1/3 gap-5 p-5 shadow-lg bg-gradient-to-b from-manage1 to-manage2 rounded-3xl">
          <img src={maker} alt="logo" className=" h-60" />
          <div className="flex flex-col w-full gap-3 px-5">
            <p className="text-xl font-semibold text-gray-800">메이커팀</p>
            <div className="text-base leading-6 text-gray-600">
              <p>· 메이커 스페이스 관리 및 운영</p>
              <p>· 아두이노, 3D 프린터, 목공 등 메이커 교육 진행</p>
              <p>· 필요한 모든 것을 뚝딱 만들어냅니다!</p>
            </div>
          </div>
        </section>
        {/* section3 */}
        <section className="flex flex-col items-center w-1/3 gap-5 p-5 shadow-lg bg-gradient-to-b from-manage1 to-manage2 rounded-3xl">
          <img src={develop} alt="logo" className=" h-60" />
          <div className="flex flex-col w-full gap-3 px-5">
            <p className="text-xl font-semibold text-gray-800">개발팀</p>
            <div className="text-base leading-6 text-gray-600">
              <p>· 천사뱃길 및 홈페이지 개발</p>
              <p>· 아두이노 등 임베디드 기기 개발</p>
              {/* <p></p> */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Company;
